import React, {useCallback, useContext, useEffect} from 'react';
import BodyContentView from '../../views/bodyContentView';
import useKeyPress from '../../../hooks/useKeyPress';
import CommandsContext from '../../../context/commandsContext';
import {useMenu} from '../../../hooks/useMenu';
import Info from '.';

function SensorTemp({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const {onUpdateCommands} = useContext(CommandsContext);
  const {onComponent} = useMenu();

  useEffect(() => {
    if (!leftPress) return;

    onLeft();
  }, [leftPress]);

  const onLeft = useCallback(() => {
    onComponent(<Info />);
  }, []);

  useEffect(() => {
    onUpdateCommands({onLeft});
  }, [onLeft]);

  return (
    <BodyContentView
      title="[016] Sensor Temp Failure"
      left="Back"
      right=""
      caption={
        <>
          <span>The value computed for the resistance of the line RTD is outside limits.</span>
          <p>1. Check the wiring between the sensor and the transmitter.</p>
          <p>
            {' '}
            a. Refer to the installation manuals and ensure that the wiring has been performed
            according to instructions. Obey all applicable safety messages.
          </p>
          <p> b. Verify that the wires are making good contact with the terminals.</p>
          <p> c. Perform RTD resistance checks and check for shorts to case.</p>
          <p> d. Check the continuity of all wires from the transmitter to the sensor.</p>
          <p>2. Check your process conditions against the values reported by the meter.</p>
          <p>3. Contact Micro Motion.</p>
        </>
      }
    />
  );
}

export default SensorTemp;
